module.exports = __webpack_public_path__ + "img/tvEnabled.f9cc59.svg";